<template>
  <footer class="c-cbr-Footer">
    <div class="c-cbr-Footer-links">
      <div class="c-cbr-Footer-linksItem">
        <router-link
          :to="impressumLink"
          class="c-cbr-Footer-link"
        >{{ $t('impressum') }}</router-link>
      </div>
      <div class="c-cbr-Footer-linksItem">
        <a
          class="c-cbr-Footer-link"
          href="https://gls-group.eu/EU/en/dataprotection"
          target="_blank"
        >{{ $t('data_protection') }}</a>
      </div>
      <div class="c-cbr-Footer-linksItem">
        <router-link
          :to="accessibilityLink"
          class="c-cbr-Footer-link"
        >{{ $t('accessibility.accessibility_statement') }}</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      stage: process.env.STAGE
    }
  },
  computed: {
    ...mapState('config', ['identifier']),
    impressumLink() {
      return `/c/${this.identifier}/impressum`
    },
    accessibilityLink() {
      return `/c/${this.identifier}/accessibility`
    }
  }
}
</script>



// WEBPACK FOOTER //
// client/components/CbrFooter.vue